import { ISnippet } from "./snippet";

export interface IEditorBackend {
  id: number | null;
  title: string;
  sub_headline: string;
  content: string | null;
  article: number;
  owner: number | null;
}

export interface IEditor {
  id: number | null;
  title: string;
  subHeadline: string;
  content: string;
  snippets: ISnippet[];
}

const defaultEditor = {
  id: null,
  title: "",
  subHeadline: "",
  content: "",
  snippets: [],
};

export const createEditor = (editor: IEditorBackend): IEditor => {
  if (!editor) return defaultEditor;
  return Object.freeze({
    id: editor.id,
    title: editor.title,
    subHeadline: editor.sub_headline,
    content: editor.content ? editor.content : "",
    snippets: [],
  });
};

export const createEditorBackend = (
  editor: IEditor,
  articleId: number
): IEditorBackend => {
  return Object.freeze({
    id: null,
    article: articleId,
    content: editor.content,
    title: editor.title,
    sub_headline: editor.subHeadline,
    owner: null,
  });
};
